const actions = {
  SET_ORDER_SOURCE: 'SET_ORDER_SOURCE',

  /**
   * Tags the in-progress order with the entry point it originated from
   * (e.g. 'dashboard'). Pass null to clear. Lives in Redux because the job
   * submission flow spans several SPA navigations where router location.state
   * and query params do not survive to the final submit.
   */
  setOrderSource: (source: string | null) => ({
    type: actions.SET_ORDER_SOURCE,
    payload: source,
  }),
};

export default actions;
